import { render, staticRenderFns } from "./MultiLink.vue?vue&type=template&id=0bde8f46&scoped=true&"
import script from "./MultiLink.vue?vue&type=script&lang=ts&"
export * from "./MultiLink.vue?vue&type=script&lang=ts&"
import style0 from "./MultiLink.vue?vue&type=style&index=0&id=0bde8f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bde8f46",
  null
  
)

export default component.exports